// src/components/Product/ProductCard/AddToCartButton.js
import React from 'react';
import { Button, Box } from '@mui/material';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';

const AddToCartButton = ({ onAddToCart, isMobile }) => {
  return (
    <Box sx={{ 
      p: isMobile ? 1.5 : 2, 
      pt: 0,
      pb: isMobile ? 2 : 2,
      mt: 'auto'
    }}>
      <Button
        fullWidth
        onClick={onAddToCart}
        sx={{
          position: 'relative',
          backgroundColor: '#f5f5f5',
          color: '#0f3662',
          border: '2px solid #0f3662',
          py: isMobile ? 1 : 1.5,
          borderRadius: 2,
          fontWeight: 'bold',
          fontSize: isMobile ? '0.75rem' : '1rem',
          overflow: 'visible',
          transition: 'all 0.3s ease',
          boxSizing: 'border-box',
          minHeight: isMobile ? '40px' : '48px',
          '& .button-text': {
            transition: 'opacity 0.3s ease',
          },
          '& .button-icon': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            opacity: 0,
            transition: 'opacity 0.3s ease',
          },
          '&:hover': {
            backgroundColor: '#0f3662',
            color: '#fff',
            borderColor: '#0f3662',
            '& .button-text': {
              opacity: isMobile ? 1 : 0,
            },
            '& .button-icon': {
              opacity: isMobile ? 0 : 1,
            },
          },
        }}
      >
        <Box className="button-text" component="span">
          أضف إلى السلة
        </Box>
        {!isMobile && <ShoppingBagIcon className="button-icon" />}
      </Button>
    </Box>
  );
};

export default AddToCartButton;
